import React from 'react';
import BulmaSection from 'react-bulma-components/lib/components/section';
import './style.scss';

export const Section = ({ children, size, ...props }) => (
  <BulmaSection size={size} {...props}>
    {children}
  </BulmaSection>
);

export default Section;
